<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'My Vehicle Offers | AutoCheck.com',
    meta: [{ name: 'description', content: 'My Vehicle Offers' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="row navMarginMobile" :class="$style.intro">
      <div class="container mt-4">
        <div class="col-12">
          <h1 class="titleBlue">You own it. Now get help caring for it.</h1>
        </div>

        <div class="col-md-6 col-12">
          <span
            >Get expert advice, deep discounts, plus schedule, approve or
            decline, and pay for service.</span
          >
        </div>
      </div>
    </div>
    <div :class="$style.caHero">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-12">
            <div :class="$style.heroLeft">
              The CarAdvise platform provides you with tools that help you
              manage your vehicle with ease, all from one location.<br />
              <a
                href="https://app.caradvise.com/#/sign_up/1?affiliation=autocheck&amp;utm_source=autocheck_lp1t"
                target="_blank"
                class="ca-btn-enroll"
                >Sign Up for Free</a
              >
            </div>
          </div>
          <div class="col-md-4 col-12">
            <img src="https://www.autocheck.com/communications/ca-app.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="container" :class="$style.about">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="ca-main-left">
            <h3 class="titleBlue">How CarAdvise Works</h3>
            <p
              ><span>Convenient Scheduling</span><br />Locate a shop and book
              service.</p
            >
            <p
              ><span>Electronic Authorization</span><br />Approve or decline
              work on the spot, from anywhere.</p
            >
            <p
              ><span>Pay &amp; Pickup</span><br />Approve or decline work on the
              spot, from anywhere.</p
            >
          </div>
        </div>
        <div class="col-md-6 col-12" style="padding-top: 70px;">
          <div class="ca-main-right">
            <h3 class="titleBlue">Simplified Car Care</h3>
            <p
              ><span>FREE Membership &amp; Deep Discounts</span><br />Prices
              average 25% lower than retail in the CarAdvise nationwide vetted
              network of 20,000 shops.</p
            >
            <p
              ><span>FREE Expert Advice in Real-Time</span><br />Questions? Get
              FREE ASE Certified Mechanic advice to help decide if recommended
              services are necessary.</p
            >
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.footer">
      <div class="container">
        <div class="row" :class="$style.signUp">
          <div class="col-md-6 col-12 mb-3"
            ><h3
              >Enroll with<br />
              CarAdvise today!</h3
            ><a
              href="https://app.caradvise.com/#/sign_up/1?affiliation=autocheck&amp;utm_source=autocheck_lp1b"
              target="_blank"
              class="ca-btn-enroll-bottom"
              >Sign Up for Free</a
            ></div
          >
          <div class="col-md-6 col-12 mt-3"
            ><iframe
              src="https://www.youtube.com/embed/sMiNdut8F3k?rel=0&amp;controls=0&amp;showinfo=0"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen=""
            ></iframe
          ></div>
        </div>
        <div class="row" :class="$style.disclaimer">
          <div class="col-12 text-center">
            The CarAdvise service and logo is provided by CarAdvise LLC.<br />Learn
            more at
            <a
              href="https://caradvise.com?utm_source=autocheck_lp1f"
              target="_blank"
              >CarAdvise.com</a
            >
            <br /><br />Advertiser Disclosure: The offer that appears here is
            from a third party company ("our partner") from which Experian
            Automotive may receive compensation.<br />Any compensation does not
            impact how or where the product appears on this site. The offer on
            this page does not represent all available automotive services,
            companies, or products.</div
          ></div
        >
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.caHero {
  display: flex;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 100px;
  color: #fff;
  background: url('@assets/images/ca-bg-hero2.png') no-repeat top right;
  background-size: cover;

  @media screen and (min-width: 768px) {
    height: 300px;
  }

  @media screen and (max-width: 768px) {
    text-align: center;
  }
  img {
    display: block;
    width: 100%;
    max-width: 250px !important;
    margin-top: -60px;
    margin-right: auto;
    margin-left: auto;
  }
}
.heroLeft {
  flex: 1;
  padding: 70px 100px 90px 100px;
  font-size: 16px;
  line-height: 2;

  @media screen and (max-width: 768px) {
    padding: 70px 20px;
  }

  a {
    display: inline-block;
    padding: 10px 30px;
    margin-top: 30px;
    font-size: 12px;
    font-weight: bold;
    color: #f8991d;
    text-decoration: none;
    background: #fff;
    filter: drop-shadow(2px 2px 5px #666);
    border-radius: 6px;
  }
}
.about {
  span {
    font-weight: bold;
    color: #09f;
  }
  h3 {
    margin-bottom: 30px;
  }
  p {
    line-height: 2;
    color: #666;
  }
}
.footer {
  width: 100%;

  @media screen and (min-width: 768px) {
    margin-top: 90px;
  }

  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #fff;
  background: url(https://www.autocheck.com/communications/ca-bg-bottom.svg)
    no-repeat top right;
  background-size: cover;
  h3 {
    @media screen and (max-width: 768px) {
      color: #004990 !important;
    }
  }
  iframe {
    width: 500px;
    max-width: 100%;
    height: 240px;
  }
}
.disclaimer {
  padding-bottom: 50px;
  font-size: 12px;
  font-weight: normal;
  color: #fff;
  a {
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
}
.intro {
  padding-top: 50px;
  span {
    margin-top: 20px;
    font-size: 20px;
    line-height: 2;
    color: #666;
  }
}
.signUp {
  padding: 50px 0;
  a {
    display: inline-block;
    padding: 15px 30px;
    margin-top: 30px;
    margin-left: 50px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    background: #f8991d;
    filter: drop-shadow(2px 2px 5px #333);
    border-radius: 6px;
  }
  h3 {
    @media screen and (min-width: 768px) {
      padding-top: 50px;
      padding-left: 50px;
    }

    font-size: 30px;
    color: #fff;
  }
}
</style>
